import type { IconSvgElement } from '@hugeicons/react-native';
import { HugeiconsIcon } from '@hugeicons/react-native';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Colors } from '../constants/Colors';
import { Button } from './Button';
import { TextReg } from './StyledText';

type Props = {
  icon?: IconSvgElement;
  text: string;
  buttonText?: string;
  onButtonPress?: () => void;
};

export const EmptyState: React.FC<Props> = ({
  icon,
  text,
  buttonText,
  onButtonPress,
}) => {
  return (
    <View style={styles.emptyContainer}>
      {icon && <HugeiconsIcon icon={icon} size={32} color={Colors.opacity50} />}
      <TextReg style={styles.emptyText}>{text}</TextReg>
      {buttonText && onButtonPress && (
        <Button onPress={onButtonPress} style={styles.createButton}>
          {buttonText}
        </Button>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  emptyContainer: {
    height: 200,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.opacity05,
    borderRadius: 12,
    marginTop: 20,
    paddingHorizontal: 20,
    gap: 24,
  },
  emptyText: {
    fontSize: 16,
    color: Colors.opacity50,
    textAlign: 'center',
    lineHeight: 24,
  },
  createButton: {
    backgroundColor: Colors.opacity20,
  },
});
